export default __webpack_public_path__ + "static/media/book.4935a1c5.svg";